var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSimulator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "simulator_svg__svg325",
    width: 227,
    height: 227,
    viewBox: "0 0 227 227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "simulator_svg__defs316"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "simulator_svg__Rectangle_3254",
    width: 227,
    height: 227,
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    id: "simulator_svg__feOffset305",
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "simulator_svg__feGaussianBlur307",
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    id: "simulator_svg__feFlood309",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "simulator_svg__feComposite311",
    in2: "blur",
    operator: "in",
    result: "result1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    id: "simulator_svg__feComposite313",
    in: "SourceGraphic",
    in2: "result1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "simulator_svg__logo-simulator",
    transform: "translate(-2491 -3945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "simulator_svg__g319",
    filter: "url(#simulator_svg__Rectangle_3254)",
    transform: "matrix(1, 0, 0, 1, 2491, 3945)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "simulator_svg__Rectangle_3254-2",
    width: 209,
    height: 209,
    fill: "#C66378",
    fillOpacity: 1,
    rx: 30,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "simulator_svg__simulator",
    transform: "translate(2519.82 3981.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "simulator_svg__path321",
    fill: "#ffffff",
    fillOpacity: 1,
    strokeWidth: 4,
    d: "m 142.33939,43.44481 a 24,24 0 1 0 -28.36,23.6 20.28,20.28 0 0 1 -4,12 c -5.24,6.52 -15.999994,7.56 -27.239994,8.6 a 69.4,69.4 0 0 0 -24.000001,5.08 20,20 0 0 0 -2.92,1.72 v -46.68 a 24,24 0 1 0 -9.6,0 v 58.6 a 24,24 0 1 0 11.16,0.36 12,12 0 0 1 5.68,-5.4 62.2,62.2 0 0 1 20.680001,-4 c 12.8,-1.2 26.039994,-2.44 33.839994,-12 a 29.52,29.52 0 0 0 5.92,-18.2 24,24 0 0 0 18.84,-23.68 z m -105.599995,-19.2 a 14.4,14.4 0 1 1 14.4,14.4 14.4,14.4 0 0 1 -14.4,-14.4 z m 28.8,105.64 a 14.4,14.4 0 1 1 -14.44,-14.4 v 0 a 14.4,14.4 0 0 1 14.28,14.4 z m 56.359995,-72.479999 -3.52,0.44 a 14.4,14.4 0 1 1 3.52,-0.44 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulator);
export default __webpack_public_path__ + "static/media/simulator.4250be44040c2613afb1dc787656ef3e.svg";
export { ForwardRef as ReactComponent };